<template>
<div v-if="settingsPerm">
    <div v-if="settingsPerm.app">
      <!-- we are on conference website -->
       <ConferenceBrandExp v-bind:settingsPerm="settingsPerm"></ConferenceBrandExp>
    </div>
    <div v-if="!settingsPerm.app">

        <div>
            <!-- <brandHeader v-bind:settingsPerm="settingsPerm"></brandHeader> -->
        </div>
        <div class='d-flex flex-wrap p-0'>
            <div class="col-12 col-lg-9 p-0">
                <!-- left side features wrapper  -->
                <brandRelatedFeatures v-bind:widgetMainOne="widgetMainOne" v-bind:widgetMainTwo="widgetMainTwo" v-bind:rightSideWidgetTop="rightSideWidgetTop" v-bind:rightSideWidgetBottom="rightSideWidgetBottom" v-bind:settingsPerm="settingsPerm">
                </brandRelatedFeatures>

                <div v-if="result && result.brandComplex && result.brandComplex.BrandComplex 
      && result.brandComplex.BrandComplex.categoryIds && result.brandComplex.BrandComplex.categoryIds.length">
                    <div v-for="(aCategoryId, index) in result.brandComplex.BrandComplex.categoryIds.slice(0,4)" :key="index" class="my-5">
                        <categoryFeature v-bind:aCategoryId="aCategoryId" v-bind:brandData="result.brandComplex.BrandComplex" v-bind:categories="result.brandComplex.BrandComplex.categories"></categoryFeature>
                    </div>
                </div>
            </div>
            <div class='d-none d-lg-block col-3 pr-0 test'>
                <!-- rightSIde widgets wrapper  -->
                <div class="pl-3 right-side-wrapper-sticky">
                    <div class="top-widget-zindex " v-if="rightSideWidgetTop">
                        <span v-html="rightSideWidgetTop"></span>
                    </div>
                </div>
                <div class="pl-3">
                    <div class="mt-3 bottom-widget-zindex" v-if="rightSideWidgetBottom">
                        <span v-html="rightSideWidgetBottom"></span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import categoryFeature from './CategoryFeature.vue';
import ConferenceBrandExp from './ConferenceBrandExp.vue';

export default {
    name: "brandMain",

    created() {
    },

    components: {
        categoryFeature,
        ConferenceBrandExp
    },

    data() {
        return {
            widgetMainOne: false,
            widgetMainTwo: false,
            rightSideWidgetTop: false,
            rightSideWidgetBottom: false,
            brandSlug: false,
            result: null,
        };
    },

    props: {
        settingsPerm: Object,
    },

    methods: {
    },
};

</script>

<style scoped>
@media (min-width: 992px) {
    .right-side-wrapper-sticky {
        position: sticky;
        top: 100px;
    }
}

.bottom-widget-zindex {
    z-index: 50;
}

.top-widget-zindex {
    z-index: 100;
}
</style>
